
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/render/cas/[casid]",
      function () {
        return require("private-next-pages/page/render/cas/[casid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/render/cas/[casid]"])
      });
    }
  